import { basicEnum } from "./base";

export const ProductInternetTypeEnum = basicEnum([
    {
        label: "BROADBAND",
        value: "broadband",
    },
    {
        label: "DEDICATED",
        value: "dedicated",
    },
]);

export namespace ProductInternetTypeEnum {
    export type Labels = (typeof ProductInternetTypeEnum)["labels"][number];
    export type Values = (typeof ProductInternetTypeEnum)["values"][number];
}
